<div class="bigger-container d-flex p-4 gap-3">
  <div class="left-section bg-primary p-3 rounded d-flex flex-column gap-3">
    <p
      role="button"
      class="px-5"
      [ngClass]="{ selected: step === 0 }"
      (click)="changeTab(0)"
    >
      Anagrafica
    </p>
    <p
      role="button"
      class="px-5"
      [ngClass]="{ selected: step === 1 }"
      (click)="changeTab(1)"
    >
      Indirizzi
    </p>
    <p
      role="button"
      class="px-5"
      [ngClass]="{ selected: step === 2 }"
      (click)="changeTab(2)"
    >
      A carico
    </p>
  </div>

  <div class="right-section w-100">
    <div *ngIf="user">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <button (click)="goBack()" class="btn btn-primary text-white">
          &leftarrow; Torna alla lista
        </button>
        <h2>Dettagli Utente: {{ user.name }} {{ user.surname }}</h2>

        <button (click)="saveForm()" class="btn btn-primary text-white">
          Salva
        </button>
      </div>

      <!-- * ANAGRAFICA -->
      <div *ngIf="step === 0" class="card p-3">
        <form [formGroup]="form">
          <div class="row g-3">
            <!-- Photo -->
            <div class="col-12 d-flex align-items-center gap-4 mb-2">
              <div class="d-flex flex-column align-items-center gap-1">
                <img
                  *ngIf="form.get('photoURL')?.value; else noImage"
                  [src]="form.get('photoURL')?.value"
                  alt="Foto utente"
                  class="rounded-circle object-fit-cover border"
                  style="width: 90px; height: 90px"
                  (error)="onImageError($event)"
                />
                <ng-template #noImage>
                  <div
                    class="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white"
                    style="width: 90px; height: 90px; font-size: 2rem"
                  >
                    <i class="bi bi-person-fill"></i>
                  </div>
                </ng-template>
                <small class="text-muted">
                  {{
                    form.get("photoURL")?.value
                      ? "Immagine presente"
                      : "Nessuna immagine"
                  }}
                </small>
              </div>
            </div>
            <!-- UID -->
            <div class="col-md-6">
              <label class="form-label fw-semibold">UID</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control bg-light"
                  formControlName="uid"
                  readonly
                />
              </div>
            </div>

            <!-- Nome -->
            <div class="col-md-6">
              <label class="form-label fw-semibold" for="name"
                >Nome <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="name"
                formControlName="name"
              />
            </div>

            <!-- Cognome -->
            <div class="col-md-6">
              <label class="form-label fw-semibold" for="surname"
                >Cognome <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="surname"
                formControlName="surname"
              />
            </div>

            <!-- Email -->
            <div class="col-md-6">
              <label class="form-label fw-semibold" for="email"
                >Email <span class="text-danger">*</span></label
              >
              <div class="input-group">
                <input
                  type="email"
                  class="form-control bg-light"
                  id="email"
                  formControlName="email"
                  readonly
                />
              </div>
            </div>

            <!-- Telefono -->
            <div class="col-md-6">
              <label class="form-label fw-semibold" for="phone"
                >Telefono <span class="text-danger">*</span></label
              >
              <div class="input-group">
                <input
                  type="tel"
                  class="form-control"
                  id="phone"
                  formControlName="phone"
                />
              </div>
            </div>

            <!-- Azienda B2B -->
            <div *ngIf="user.workInfo" class="col-md-6">
              <label class="form-label fw-semibold">Azienda</label>
              <app-b2b-company-select
                formControlName="b2bCompany"
              ></app-b2b-company-select>
            </div>
          </div>
        </form>
      </div>

      <!-- * INDIRIZZI -->
      <div *ngIf="step === 1" class="card">
        <div class="d-flex justify-content-between align-items-center p-3">
          <h3>Indirizzi</h3>
          <button (click)="newAddress()" class="btn btn-primary text-light">
            + Nuovo
          </button>
        </div>

        <div class="p-3">
          <form [formGroup]="form">
            <div formArrayName="addresses">
              <table class="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Via</th>
                    <th>Città</th>
                    <th>CAP</th>
                    <th>Provincia</th>
                    <th>Azioni</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Form per nuovo indirizzo -->
                  <tr
                    *ngIf="expandedAddressIndex === -1"
                    [formGroup]="newAddressForm"
                  >
                    <td colspan="6">
                      <div class="card border-0 bg-light p-3">
                        <div class="row">
                          <div class="col-md-6">
                            <label class="form-label">Via</label>
                            <input
                              type="text"
                              class="form-control"
                              formControlName="street"
                              #newStreetInput
                              (focus)="
                                initAutocomplete(newStreetInput, newAddressForm)
                              "
                            />
                          </div>
                          <div class="col-md-3">
                            <label class="form-label">Città</label>
                            <input
                              type="text"
                              class="form-control"
                              formControlName="city"
                            />
                          </div>
                          <div class="col-md-3">
                            <label class="form-label">CAP</label>
                            <input
                              type="text"
                              class="form-control"
                              formControlName="postalCode"
                            />
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-3">
                            <label class="form-label">Provincia</label>
                            <input
                              type="text"
                              class="form-control"
                              formControlName="province"
                            />
                          </div>
                          <div class="col-md-3">
                            <label class="form-label">Zona</label>
                            <input
                              type="text"
                              class="form-control"
                              formControlName="zone"
                            />
                          </div>
                          <div class="col-md-3">
                            <div class="form-check mt-4">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                formControlName="active"
                                id="active-new"
                              />
                              <label
                                class="form-check-label"
                                [for]="'active-new'"
                              >
                                Attivo
                              </label>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="form-check mt-4">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                formControlName="isDefault"
                                id="isDefault-new"
                              />
                              <label
                                class="form-check-label"
                                [for]="'isDefault-new'"
                              >
                                Predefinito
                              </label>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="d-flex gap-2 mt-4">
                              <button
                                type="button"
                                class="btn btn-success btn-sm"
                                (click)="saveNewAddress()"
                              >
                                Aggiungi indirizzo
                              </button>
                              <button
                                type="button"
                                class="btn btn-secondary text-light btn-sm"
                                (click)="cancelAddressEdit(-1)"
                              >
                                Annulla
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <ng-container
                    *ngFor="
                      let addressControl of getAddressesControls();
                      let i = index
                    "
                  >
                    <!-- Riga della tabella -->
                    <tr
                      role="button"
                      (click)="toggleAddressEdit(i)"
                      [ngClass]="{ 'table-active': expandedAddressIndex === i }"
                    >
                      <td>{{ addressControl.get("id")?.value }}</td>
                      <td>{{ addressControl.get("street")?.value }}</td>
                      <td>{{ addressControl.get("city")?.value }}</td>
                      <td>{{ addressControl.get("postalCode")?.value }}</td>
                      <td>{{ addressControl.get("province")?.value }}</td>
                      <td class="d-flex gap-2">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-primary"
                          (click)="
                            $event.stopPropagation(); toggleAddressEdit(i)
                          "
                        >
                          {{
                            expandedAddressIndex === i ? "Chiudi" : "Modifica"
                          }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-danger"
                          (click)="$event.stopPropagation(); deleteAddress(i)"
                        >
                          Elimina
                        </button>
                      </td>
                    </tr>
                    <!-- Form espandibile -->
                    <tr *ngIf="expandedAddressIndex === i">
                      <td colspan="6">
                        <div
                          class="card border-0 bg-light p-3"
                          [formGroupName]="i"
                        >
                          <div class="row">
                            <div class="col-md-6">
                              <label class="form-label">Via</label>
                              <input
                                type="text"
                                class="form-control"
                                formControlName="street"
                                #streetInput
                                (focus)="
                                  initAutocomplete(
                                    streetInput,
                                    getAddressesControls()[i]
                                  )
                                "
                              />
                            </div>
                            <div class="col-md-3">
                              <label class="form-label">Città</label>
                              <input
                                type="text"
                                class="form-control"
                                formControlName="city"
                              />
                            </div>
                            <div class="col-md-3">
                              <label class="form-label">CAP</label>
                              <input
                                type="text"
                                class="form-control"
                                formControlName="postalCode"
                              />
                            </div>
                          </div>
                          <div class="row mt-3">
                            <div class="col-md-3">
                              <label class="form-label">Provincia</label>
                              <input
                                type="text"
                                class="form-control"
                                formControlName="province"
                              />
                            </div>
                            <div class="col-md-3">
                              <label class="form-label">Zona</label>
                              <input
                                type="text"
                                class="form-control"
                                formControlName="zone"
                              />
                            </div>
                            <div class="col-md-3">
                              <div class="form-check mt-4">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                  formControlName="active"
                                  id="active-{{ i }}"
                                />
                                <label
                                  class="form-check-label"
                                  [for]="'active-' + i"
                                >
                                  Attivo
                                </label>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <div class="form-check mt-4">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                  formControlName="isDefault"
                                  id="isDefault-{{ i }}"
                                />
                                <label
                                  class="form-check-label"
                                  [for]="'isDefault-' + i"
                                >
                                  Predefinito
                                </label>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="d-flex gap-2 mt-4">
                                <button
                                  type="button"
                                  class="btn btn-success btn-sm"
                                  (click)="saveAddress(i)"
                                >
                                  Salva indirizzo
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-secondary text-light btn-sm"
                                  (click)="cancelAddressEdit(i)"
                                >
                                  Annulla
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
      <!-- * A CARICO -->
      <div *ngIf="step === 2" class="card">
        <div class="d-flex justify-content-between align-items-center p-3">
          <h3>A carico</h3>
          <button (click)="newDependant()" class="btn btn-primary text-light">
            + Nuovo
          </button>
        </div>
        <div class="p-3">
          <form [formGroup]="form">
            <div formArrayName="dependants">
              <table class="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Nome</th>
                    <th>Tipo</th>
                    <th>Data di Nascita</th>
                    <th>Genere</th>
                    <th>Handicap</th>
                    <th>Azioni</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Form per nuovo dependant -->
                  <tr
                    *ngIf="expandedDependantIndex === -1"
                    [formGroup]="newDependantForm"
                  >
                    <td colspan="7">
                      <div class="card border-0 bg-light p-3">
                        <div class="row">
                          <div class="col-md-4">
                            <label class="form-label"
                              >Nome<span class="red">*</span></label
                            >
                            <input
                              type="text"
                              class="form-control"
                              formControlName="name"
                            />
                          </div>
                          <div class="col-md-4">
                            <label class="form-label"
                              >Tipo<span class="red">*</span></label
                            >
                            <select class="form-control" formControlName="type">
                              <option value="">Seleziona tipo</option>
                              <option value="PERSON">PERSON</option>
                              <option value="DOG">DOG</option>
                              <option value="CAT">CAT</option>
                              <option value="OTHER">OTHER</option>
                            </select>
                          </div>
                          <div class="col-md-4">
                            <label class="form-label"
                              >Data di Nascita<span class="red">*</span></label
                            >
                            <input
                              type="date"
                              class="form-control"
                              formControlName="birthDate"
                            />
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-4">
                            <label class="form-label"
                              >Genere<span class="red">*</span></label
                            >
                            <select
                              class="form-control"
                              formControlName="gender"
                            >
                              <option value="">Seleziona genere</option>
                              <option value="MALE">Maschio</option>
                              <option value="FEMALE">Femmina</option>
                            </select>
                          </div>
                          <div class="col-md-4">
                            <div class="form-check mt-4">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                formControlName="handicap"
                                id="handicap-new"
                              />
                              <label
                                class="form-check-label"
                                [for]="'handicap-new'"
                              >
                                Handicap
                              </label>
                            </div>
                          </div>
                          <span></span>
                          <div class="col-md-4">
                            <div class="d-flex gap-2 mt-4">
                              <button
                                type="button"
                                class="btn btn-success btn-sm"
                                (click)="saveNewDependant()"
                              >
                                Aggiungi a carico
                              </button>
                              <button
                                type="button"
                                class="btn btn-secondary btn-sm text-light"
                                (click)="cancelDependantEdit(-1)"
                              >
                                Annulla
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <ng-container
                    *ngFor="
                      let dependantControl of getDependantsControls();
                      let i = index
                    "
                  >
                    <!-- Riga della tabella -->
                    <tr
                      role="button"
                      (click)="toggleDependantEdit(i)"
                      [ngClass]="{
                        'table-active': expandedDependantIndex === i
                      }"
                    >
                      <td>{{ dependantControl.get("id")?.value }}</td>
                      <td>{{ dependantControl.get("name")?.value }}</td>
                      <td>{{ dependantControl.get("type")?.value }}</td>
                      <td>
                        {{
                          dependantControl.get("birthDate")?.value
                            | date : "dd/MM/yyyy"
                        }}
                      </td>
                      <td>{{ dependantControl.get("gender")?.value }}</td>
                      <td>
                        {{
                          dependantControl.get("handicap")?.value ? "Sì" : "No"
                        }}
                      </td>
                      <td class="d-flex gap-2">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-primary"
                          (click)="
                            $event.stopPropagation(); toggleDependantEdit(i)
                          "
                        >
                          {{
                            expandedDependantIndex === i ? "Chiudi" : "Modifica"
                          }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-danger"
                          (click)="$event.stopPropagation(); deleteDependant(i)"
                        >
                          Elimina
                        </button>
                      </td>
                    </tr>
                    <!-- Form espandibile -->
                    <tr *ngIf="expandedDependantIndex === i">
                      <td colspan="7">
                        <div
                          class="card border-0 bg-light p-3"
                          [formGroupName]="i"
                        >
                          <div class="row">
                            <div class="col-md-4">
                              <label class="form-label"
                                >Nome<span class="red">*</span></label
                              >
                              <input
                                type="text"
                                class="form-control"
                                formControlName="name"
                              />
                            </div>
                            <div class="col-md-4">
                              <label class="form-label"
                                >Tipo<span class="red">*</span></label
                              >
                              <select
                                class="form-control"
                                formControlName="type"
                              >
                                <option value="">Seleziona tipo</option>
                                <option value="PERSON">PERSON</option>
                                <option value="DOG">DOG</option>
                                <option value="CAT">CAT</option>
                                <option value="OTHER">OTHER</option>
                              </select>
                            </div>
                            <div class="col-md-4">
                              <label class="form-label"
                                >Data di Nascita<span class="red"
                                  >*</span
                                ></label
                              >
                              <input
                                type="date"
                                class="form-control"
                                formControlName="birthDate"
                              />
                            </div>
                          </div>
                          <div class="row mt-3">
                            <div class="col-md-4">
                              <label class="form-label"
                                >Genere<span class="red">*</span></label
                              >
                              <select
                                class="form-control"
                                formControlName="gender"
                              >
                                <option value="">Seleziona genere</option>
                                <option value="MALE">Maschio</option>
                                <option value="FEMALE">Femmina</option>
                              </select>
                            </div>
                            <div class="col-md-4">
                              <div class="form-check mt-4">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                  formControlName="handicap"
                                  id="handicap-{{ i }}"
                                />
                                <label
                                  class="form-check-label"
                                  [for]="'handicap-' + i"
                                >
                                  Handicap
                                </label>
                              </div>
                            </div>
                            <span></span>
                            <div class="col-md-4">
                              <div class="d-flex gap-2 mt-4">
                                <button
                                  type="button"
                                  class="btn btn-success btn-sm"
                                  (click)="saveDependant(i)"
                                >
                                  Salva a carico
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-secondary btn-sm text-light"
                                  (click)="cancelDependantEdit(i)"
                                >
                                  Annulla
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div *ngIf="!user" class="loading-state">
      Caricamento dettagli utente...
    </div>
  </div>
</div>
